import 'element-closest-polyfill';

import { close, open } from '../helpers';

import { Component } from '@verndale/core';

class Module extends Component {
  setupDefaults() {
    this.dom = {
      items: [...this.el.querySelectorAll('.accordion-item')],
      triggers: [...this.el.querySelectorAll('.accordion-item__button')]
    };
  }

  addListeners() {
    // Using for loop to support IE11
    for (let i = 0; i < this.dom.triggers.length; i++) {
      const el = this.dom.triggers[i];
      el.addEventListener('click', ::this.toggle);
    }
  }

  toggle(e) {
    const item = e.target.closest('.accordion-item');
    const details = item.querySelector('.accordion-item__details');
    const opened = this.dom.items.filter(el => el.classList.contains('opened'));
    const isOpen = item.classList.contains('opened');

    if (opened.length) {
      const openedDetails = opened[0].querySelector('.accordion-item__details');

      opened[0].classList.remove('opened');
      close(openedDetails);
    }

    if (isOpen) {
      item.classList.remove('opened');
      this.checkIfItsNavigationAccordion(false);
      close(details);
    } else {
      item.classList.add('opened');
      this.checkIfItsNavigationAccordion(true);
      if (item.classList.contains('mobile-navigation-v2-item')) {
        open(details, 0.6, 'easeIn', () => this.checkIfItsMenuAccordion(item));
      } else {
        open(details);
      }
    }
  }

  checkIfItsMenuAccordion(item) {
    if (item.classList.contains('mobile-navigation-v2-item')) {
      item.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
        inline: 'start'
      });
    }
  }

  checkIfItsNavigationAccordion(isOpen) {
    const cta = document.querySelector('.mobile-contact-us-v2__cta');
    if (!cta) return;

    if (isOpen) {
      return cta.classList.add('opened');
    }

    cta.classList.remove('opened');
  }
}

export default Module;
